import { useCallback, useState } from "react"
import { useSetRecoilState } from "recoil"
import { wait } from "src/utils/wait"
import { tokensState } from "src/recoil/atoms/authorization/tokensState"
import { sessionState } from "src/recoil/atoms/authorization/sessionState"
import { useAsyncState } from "src/hooks/useAsyncState"
import { removeAccountDevice } from "src/apis/auth/removeAccountDevice"
import { deleteAsync } from "src/storage/secureStorage/deleteAsync"
import { selectedMyOrganizationState } from "src/recoil/atoms/organization/selectedMyOrganizationState"
import { analyticsWrap } from "src/tags/analytics"
import { clearIchioshiUrl } from "src/storage/ichioshiStorage"
export const useSignout = () => {
  const [token] = useAsyncState(tokensState)
  const [isProcessingSignout, setIsProcessingSignout] = useState(false)
  const setSession = useSetRecoilState(sessionState)
  const setTokens = useSetRecoilState(tokensState)
  const setSelectedOrganization = useSetRecoilState(selectedMyOrganizationState)
  const signout = useCallback(async () => {
    setIsProcessingSignout(true)
    try {
      await wait(500)
      const accessToken = token?.accessToken ?? ""
      await removeAccountDevice(accessToken)
      setSession(undefined)
      setTokens(undefined)
      setSelectedOrganization(undefined)
      analyticsWrap.setUserProperties({ isLogin: "false" })
      deleteAsync("applicantInformationData")
      deleteAsync("planData")
      await clearIchioshiUrl()
    } catch (error) {
      console.error(error)
      return
    } finally {
      setIsProcessingSignout(false)
    }
  }, [setSelectedOrganization, setSession, setTokens, token?.accessToken])

  return {
    isProcessingSignout,
    signout,
  }
}
